import { Fragment, useCallback, memo, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import EPHeader from 'editor-components/header/EPHeader';
import EPNavigationBar from 'editor-components/header/EPNavigationBar';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import UsageTracker, { useTracker } from 'ContentEditorUI/utils/UsageTracker';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error not typed yet
import TranslationSelectorContainer from 'ContentEditorUI/containers/TranslationSelectorContainer';
// @ts-expect-error not typed yet
import PageAbControlsContainer from 'page-editor-ui/containers/PageAbControlsContainer';
// @ts-expect-error not typed yet
import PageMABControlsContainer from 'page-editor-ui/containers/PageMABControlsContainer';
import BreakpointsContainer from 'ContentEditorUI/containers/BreakpointsContainer';
import ExitButton from 'ContentEditorUI/components/header/ExitButton';
import PagePublishButtonContainer from 'page-editor-ui/containers/PagePublishButtonContainer';
// @ts-expect-error not typed yet
import ExitDeveloperModeButton from 'ContentEditorUI/components/ExitDeveloperModeButton';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
// @ts-expect-error not typed yet
import { getDashboardUrl } from 'page-editor-ui/redux/selectors/urlSelectors';
import { getIsInDeveloperMode, getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-expect-error not typed yet
import { getHasCurrentTranslations } from 'ContentEditorUI/redux/selectors/translationSelectors';
import { getCanUseQuickSpot } from 'ContentEditorUI/redux/selectors/authSelectors';
import { showLoading, hideLoading, openModal
// @ts-expect-error not typed yet
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed yet
import { save } from 'page-editor-ui/redux/actions/pageSaveActions';
// @ts-expect-error not typed yet
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { setShouldClearHeaderActiveItem, updateHeaderActiveItem } from 'ContentEditorUI/redux/actions/headerActions';
import { getShouldClearHeaderActiveItem } from 'ContentEditorUI/redux/selectors/headerSelectors';
import EPSettingsButton from 'editor-components/header/EPSettingsButton';
import EPSpotlightButton from 'editor-components/header/EPSpotlightButton';
import UndoRedoButtonContainer from 'ContentEditorUI/containers/UndoRedoButtonContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getShouldUseResponsiveBreakpoints } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
// @ts-expect-error not typed yet
import { useNavigationGroups } from 'page-editor-ui/hooks/useNavigationGroups';
// @ts-expect-error not typed yet
import PageSaveButtonContainer from './PageSaveButtonContainer';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';
import { getContentModelName, getPublishDate, getContentModelPageExpiryDate, getContentModelPageExpiryEnabled } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not typed yet
import { updateName } from 'ContentEditorUI/redux/actions/baseContentModelActions';
import useSetSettingsModalOpenWithNavItem from 'page-editor-ui/hooks/useSetSettingsModalOpenWithNavItem';
import ContentPublishStatus from 'ContentEditorUI/components/shared/ContentPublishStatus';
import { getHardSavedContentModelIsPublishedNotScheduled, getHardSavedContentModelIsScheduled, getHardSavedContentModelScheduledUpdateDate } from 'ContentEditorUI/redux/selectors/hardSavedContentModelSelectors';
import ContentCrmObjectProvider from 'ContentEditorUI/components/publishing/ContentCrmObjectProvider';
import { getIsLandingPage, getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { ContentObjectTypes } from 'content-management-data-lib';
import { getApprovalContentId } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
// @ts-expect-error not typed yet
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsUngatedForCMPPublishing } from 'page-editor-ui/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorToolbarEndSlot = () => {
  const dispatch = useDispatch();
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const isInDeveloperMode = useSelector(getIsInDeveloperMode);
  const handleSaveClick = useCallback(() => {
    dispatch(save());
    UsageTracker.trackEditorInteraction({
      action: 'Revisions Action',
      event: 'clicked-save'
    });
  }, [dispatch]);
  const handlePreviewClick = useCallback(() => {
    if (hasUnsavedChanges) {
      dispatch(showLoading());
      dispatch(save()).finally(() => {
        dispatch(hideLoading());
        dispatch(routeToPage('preview'));
      }).catch(error => console.error(error));
    } else {
      dispatch(routeToPage('preview'));
    }
  }, [dispatch, hasUnsavedChanges]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isInDeveloperMode && /*#__PURE__*/_jsx(ExitDeveloperModeButton, {}), /*#__PURE__*/_jsx(PageSaveButtonContainer, {
      onSaveClick: handleSaveClick
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-onboarding": "ep-navigation-preview",
        "data-campaign-assistant-onboarding-tour": "tour-step-preview",
        onClick: handlePreviewClick,
        use: "secondary-ghost",
        size: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "components.tabBar.preview"
        })
      })
    }), /*#__PURE__*/_jsx(PagePublishButtonContainer, {})]
  });
};
const PatagoniaHeaderContainer = /*#__PURE__*/memo(() => {
  const dispatch = useDispatch();
  const dashboardUrl = useSelector(getDashboardUrl);
  const hasUndoRedoAccess = useSelector(getHasUndoRedoAccess);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const shouldUseResponsiveBreakpoints = useSelector(getShouldUseResponsiveBreakpoints);
  const shouldClearHeader = useSelector(getShouldClearHeaderActiveItem);
  const pageName = useSelector(getContentModelName);
  const tracker = useTracker();
  const navigationGroups = useNavigationGroups();
  const canUseQuickSpot = useSelector(getCanUseQuickSpot);
  const hasCurrentTranslations = useSelector(getHasCurrentTranslations);
  const HEADER_CLASSNAME = 'fullscreen-editor-header';
  const handleQuickSpotOpenClick = useCallback(() => {
    dispatch(openModal(MODAL_TYPES.SPOTLIGHT));
  }, [dispatch]);
  const handleActiveItemChange = useCallback(activeItem => {
    dispatch(updateHeaderActiveItem(activeItem));
    if (activeItem) {
      dispatch(setShouldClearHeaderActiveItem(false));
    }
  }, [dispatch]);
  const setSettingsModalOpenWithNavItem = useSetSettingsModalOpenWithNavItem(MODAL_TYPES.SETTINGS_MODAL);
  const handleChangeName = e => dispatch(updateName(e.target.value));
  const isScheduled = useSelector(getHardSavedContentModelIsScheduled);
  const isPublished = useSelector(getHardSavedContentModelIsPublishedNotScheduled);
  const scheduledUpdateDate = useSelector(getHardSavedContentModelScheduledUpdateDate);
  const publishDate = useSelector(getPublishDate);
  const unpublishDate = useSelector(getContentModelPageExpiryDate);
  const unpublishEnabled = useSelector(getContentModelPageExpiryEnabled);
  const isLandingPage = useSelector(getIsLandingPage);
  const hasStagingDomain = useSelector(getHasStagingDomain);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const contentCrmObjectId = useSelector(getApprovalContentId);
  const isUngatedForPublishWithContentCrmObject = useSelector(getIsUngatedForCMPPublishing);
  const enableScheduledPublishing = !hasStagingDomain && !isBlogListingPage && isUngatedForPublishWithContentCrmObject;
  const contentObjectType = useMemo(() => {
    if (!isUngatedForPublishWithContentCrmObject) {
      return undefined;
    }
    if (isBlogListingPage) {
      return ContentObjectTypes.BLOG_LISTING_PAGE;
    }
    if (isLandingPage) {
      return ContentObjectTypes.LANDING_PAGE;
    }
    return ContentObjectTypes.SITE_PAGE;
  }, [isBlogListingPage, isLandingPage, isUngatedForPublishWithContentCrmObject]);
  return /*#__PURE__*/_jsx(ContentCrmObjectProvider
  // @ts-expect-error type should have undefined as an acceptable type
  , {
    contentObjectType: contentObjectType
    // @ts-expect-error type should have undefined as an acceptable type
    ,
    contentCrmObjectId: contentCrmObjectId,
    enableScheduledPublishing: enableScheduledPublishing,
    shouldUseContentCrmObject: isUngatedForPublishWithContentCrmObject,
    children: /*#__PURE__*/_jsx(EPHeader, {
      editorToolbarClassName: HEADER_CLASSNAME,
      tabsClassName: "m-y-2",
      shouldAdaptForBranchPreview: true,
      titleText: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(AutoSizedTextInput, {
          affordance: true,
          onChange: handleChangeName,
          use: "on-dark",
          value: pageName,
          readOnly: isReadOnlyMode
        }), /*#__PURE__*/_jsx(ContentPublishStatus, {
          isPublished: isPublished,
          isScheduled: isScheduled,
          publishDate: publishDate
          // @ts-expect-error type does not accept null
          ,
          scheduledUpdateDate: scheduledUpdateDate
          // @ts-expect-error type does not accept null
          ,
          unpublishDate: unpublishDate
          // @ts-expect-error type does not accept null
          ,
          unpublishEnabled: unpublishEnabled
        })]
      }),
      editorToolbarStartSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ExitButton, {
          dashboardUrl: dashboardUrl
        }), /*#__PURE__*/_jsx(EPNavigationBar, {
          navigationGroups: navigationGroups,
          onActiveItemChange: handleActiveItemChange,
          shouldClear: shouldClearHeader
        })]
      }),
      editorToolbarEndSlot: /*#__PURE__*/_jsx(EditorToolbarEndSlot, {}),
      tabsStartSlot: /*#__PURE__*/_jsxs(List, {
        use: "inline-divided",
        children: [hasCurrentTranslations && /*#__PURE__*/_jsx(ListItem, {
          marginInlineEnd: "50",
          children: /*#__PURE__*/_jsx(TranslationSelectorContainer, {})
        }), /*#__PURE__*/_jsx(PageMABControlsContainer, {}), /*#__PURE__*/_jsx(PageAbControlsContainer, {})]
      }),
      tabsMiddleSlot: /*#__PURE__*/_jsx(Fragment, {
        children: shouldUseResponsiveBreakpoints && /*#__PURE__*/_jsx(BreakpointsContainer, {})
      }),
      tabsEndSlot: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "end",
        children: [canUseQuickSpot && tracker && /*#__PURE__*/_jsx(EPSpotlightButton, {
          onClick: handleQuickSpotOpenClick,
          usageTracker: tracker
        }), tracker && /*#__PURE__*/_jsx(EPSettingsButton, {
          onClick: () => setSettingsModalOpenWithNavItem('general'),
          usageTracker: tracker
        }), /*#__PURE__*/_jsx(NavMarker, {
          name: "PARENT_APP_CHROME_RENDERED"
        }), hasUndoRedoAccess && /*#__PURE__*/_jsx(View, {
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(UndoRedoButtonContainer, {
            isVisible: true,
            disabled: isReadOnlyMode
          })
        })]
      })
    })
  });
});
export default PatagoniaHeaderContainer;